import script from "./ViewRouter.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewRouter.vue?vue&type=script&setup=true&lang=js"

import "./ViewRouter.vue?vue&type=style&index=0&id=81c36e3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81c36e3e"]])

export default __exports__